/**
 * Loads the statscenter utils dynamically
 * and makes the call to open StatsCenter popup.
 *
 * StatsCenter utils are dynamically loaded to avoid bundling StatsCenter Component
 * and its dependencies to the initial assets build.
 *
 * @param {String} type interaction type to call
 * @returns {Promise} the promise for the request
 */
export const statscenterInteraction = async (type) => {
    const {
        loadStatsCenter,
    } = await import(
        /* webpackChunkName: "statscenter" */
        '~shared/utils/statscenter'
    );

    switch (type) {
        case 'openStatsCenterPopup':
            loadStatsCenter();
            break;
        default:
            break;
    }
};
